const state = {
  agent: {
    list: {
      pageIndex: 1,
      pageSize: 10,
      total: 20
    },
    view: {},
    editing: {}
  }
}

export default {
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/agent.js